import { useCallback, useState, useEffect } from "react";
// import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./EditUserLimits.module.css";
import config from "../../../config/config";
import axios from "axios";
import store from "../../../Store/Store";
import companyStore from "../../../Store/Store";

const EditUserLimits = ({ isVisible, onClose, openNoti, className = "" }) => {
  const [Txnlimt, setTxnlimt] = useState("");
  const [dailyLimit, setDailyLimit] = useState("");
  const [MonthlyLimit, setMonthlyLimit] = useState("");
  const [oldRoles, setOldRoles] = useState([]);
  const [adminEnabled, setAdminEnabled] = useState(false);
  const [ownerEnabled, setOWnerEnabled] = useState(false);
  const [userEnabled, setUserEnabled] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [AllTags, setAllTags] = useState([]);
  const [errormsg, setErrorMsg] = useState({
    isAnyFieldEmpty: false,
    isTxnLimitNegative: false,
    isDailyLimitNegative: false,
    isMonthlyLimitNegative: false,
    isTxnLimitExceeds: false,
    isDailyLimitExceedsMonthly: false,
  });
  const [ErrorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setAllTags(store.Tags.filter((tag) => tag !== ""));
    setTxnlimt(companyStore.txnLimit);
    setDailyLimit(companyStore.DailyLimit);
    setMonthlyLimit(companyStore.MonthlyLimit);
  }, []);

  console.log("ownerEnabled", ownerEnabled);
  console.log("adminEnabled", adminEnabled);
  console.log("userEnabled", userEnabled);

  useEffect(() => {
    console.log("store.UserRoles", JSON.stringify(store.UserRoles));
    if (store.UserRoles.includes("OWNER")) {
    }
    if (store.UserRoles.includes("OWNER")) {
      setOWnerEnabled(true);
      if (!oldRoles.includes("OWNER")) {
        oldRoles.push("OWNER");
      }
      console.log("====>Owner");
    }
    if (store.UserRoles.includes("ADMIN")) {
      setAdminEnabled(true);
      if (!oldRoles.includes("ADMIN")) {
        oldRoles.push("ADMIN");
      }
      console.log("====>Admin");
    }
    if (store.UserRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
      setUserEnabled(true);
      if (!oldRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
        oldRoles.push("CUPI_COMPANY_EMPLOYEE");
      }
      console.log("====>users");
    }
    if (store.UserRoles.length == 0) {
      setOWnerEnabled(false);
      setAdminEnabled(false);
      setUserEnabled(false);
      console.log("diabled");
    }
    console.log("oldRoles", oldRoles);
  }, []);

  const onFrameButtonClick = () => {
    setErrorMsg({
      isAnyFieldEmpty: false,
      isTxnLimitNegative: false,
      isDailyLimitNegative: false,
      isMonthlyLimitNegative: false,
      isTxnLimitExceeds: false,
      isDailyLimitExceedsMonthly: false,
    });
    if (
      (Txnlimt == "" || dailyLimit == "" || MonthlyLimit == "") &&
      userEnabled
    ) {
      console.log("error");

      setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
      setErrorMessage("All Fields are required");
      return;
    }
    if (
      userEnabled &&
      (Number(dailyLimit) <= 0 ||
        Number(Txnlimt) <= 0 ||
        Number(MonthlyLimit) <= 0)
    ) {
      if (Number(dailyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isDailyLimitNegative: true }));
      }
      if (Number(Txnlimt) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isTxnLimitNegative: true }));
      }
      if (Number(MonthlyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isMonthlyLimitNegative: true }));
      }
      setErrorMessage("Limits Cannot be 0");
      return;
    }
    if (
      Number(Txnlimt) > Number(dailyLimit) ||
      Number(Txnlimt) > Number(MonthlyLimit)
    ) {
      setErrorMsg((prev) => ({ ...prev, isTxnLimitExceeds: true }));
      setErrorMessage(
        "Transaction Limit should not be greater than dailyLimit or monthlyLimit"
      );
      return;
    }
    if (Number(dailyLimit) > Number(MonthlyLimit)) {
      setErrorMsg((prev) => ({ ...prev, isDailyLimitExceedsMonthly: true }));
      setErrorMessage("Daily Limit should not be greater than monthlyLimit");
      return;
    }
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    let newRoles = [];
    if (ownerEnabled) {
      newRoles.push("OWNER");
    }
    if (adminEnabled) {
      newRoles.push("ADMIN");
    }
    if (userEnabled) {
      newRoles.push("CUPI_COMPANY_EMPLOYEE");
    }
    const haveRolesChanged = (oldRoles, newRoles) => {
      // Check if lengths differ
      if (oldRoles.length !== newRoles.length) return true;

      // Check if any role is different (order-independent)
      return (
        oldRoles.some((role) => !newRoles.includes(role)) ||
        newRoles.some((role) => !oldRoles.includes(role))
      );
    };

    const rolesChanged = haveRolesChanged(oldRoles, newRoles);
    console.log("Roles have changed:", rolesChanged);
    if (rolesChanged) {
      setSuccessMessage("Role has been updated");
    }
    if (
      Number(companyStore.txnLimit) != Number(Txnlimt) ||
      Number(companyStore.DailyLimit) != Number(dailyLimit) ||
      Number(companyStore.MonthlyLimit) != Number(MonthlyLimit)
    ) {
      setSuccessMessage(
        "The user transaction limits have been successfully updated"
      );
    }

    if (
      rolesChanged &&
      (Number(companyStore.txnLimit) != Number(Txnlimt) ||
        Number(companyStore.DailyLimit) != Number(dailyLimit) ||
        Number(companyStore.MonthlyLimit) != Number(MonthlyLimit))
    ) {
      setSuccessMessage(
        "The user transaction limits and roles have been updated"
      );
    }
    let obj;
    if (newRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
      obj = JSON.stringify({
        ledger_label: store.Company_Id,
        user_id: store.userId,
        create_at: store.create_at,
        perTxnLimit: Number(Txnlimt),
        dailyLimit: Number(dailyLimit),
        monthlyLimit: Number(MonthlyLimit),
        roles: newRoles,
        tags: AllTags.join(", "),
      });
    } else {
      obj = JSON.stringify({
        ledger_label: store.Company_Id,
        user_id: store.userId,
        create_at: store.create_at,
        perTxnLimit: 0,
        dailyLimit: 0,
        monthlyLimit: 0,
        roles: newRoles,
        tags: AllTags.join(", "),
      });
    }

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/cupi_user_update_limit`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };

    console.log("payload", obj);

    axios
      .request(payload)
      .then(async (res) => {
        setIsUpdated(true);
        store.setTxnLimit(Number(Txnlimt));
        store.setDailyLimit(Number(dailyLimit));
        store.setmonthlyLimit(Number(MonthlyLimit));
        store.refresh ? store.setRefresh(false) : store.setRefresh(true);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        setIsUpdated(false);
      })
      .catch((err) => {
        console.log(err);
        // setIsUpdated(true);
      });
  };

  const removeTag = (data, index) => {
    setAllTags((prevTags) => {
      const newTags = [...prevTags];
      newTags.splice(index, 1);
      return newTags;
    });
  };
  if (!isVisible) return null;
  return (
    <div
      className={styles.frameParent}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles.frameGroup}
        onClick={() => {
          store.refresh ? store.setRefresh(false) : store.setRefresh(true);
          onClose();
        }}
      >
        <img className={styles.arrowNarrowLeftIcon} alt="" src="/xclose.svg" />
      </div>
      <div className={styles.frameParent1}>
        <div className={styles.frameWrapperContainer}>
          <div className={styles.frameWrapper}>
            <div className={styles.mobileMenuParentHeading}>
              Edit user details
            </div>

            <div className={styles.mobileMenuParent22}>
              <div className={styles.mobileMenuContainer}>
                <div className={styles.mobileMenuele1}>NAME</div>
                <div className={styles.mobileMenuele2}>{store.name}</div>
              </div>
              <div className={styles.mobileMenuContainer}>
                <div className={styles.mobileMenuele1}>USER PHONE NO</div>
                <div className={styles.mobileMenuele2}>
                  {store.SelectedPhoneNo}
                </div>
              </div>
              <div className={styles.mobileMenuContainer}>
                <div className={styles.mobileMenuele1}>USER EMAIL ID</div>
                <div className={styles.mobileMenuele2}>
                  {store.selectedEmail == "undefined"
                    ? "-"
                    : store.selectedEmail}
                </div>
              </div>
              {companyStore.userType == "AxisUser" && (
                <div className={styles.mobileMenuContainer1}>
                  <div className={styles.mobileMenuele1}>TAGS</div>
                  <div className={styles.setTransactionTagLimit}>
                    {AllTags.map((data, index) => {
                      return (
                        <>
                          {data !== "" && (
                            <div className={styles.setTransactionOneTag}>
                              {data}
                              {/* <button
                                className={styles.setTransactionButton}
                                onClick={() => {
                                  removeTag(data, index);
                                }}
                              >
                                <img
                                  className={styles.arrowNarrowLeftIcon1}
                                  alt=""
                                  src="/Close.svg"
                                />
                              </button> */}
                            </div>
                          )}
                        </>
                      );
                    })}
                    {AllTags.length == 0 && (
                      <div className={styles.mobileMenuele2}>
                        No tags available.
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.setTransactionLimitWrapper}>
            <div className={styles.addUserDetails}>Set transaction limit</div>
          </div>
          <div className={styles.frameWrapper1}>
            <div className={styles.mobileMenuParent}>
              <div className={styles.mobileMenu}>
                <TextField
                  color="primary"
                  value={Txnlimt}
                  type="number"
                  required
                  disabled={(!(!adminEnabled || store.isUserOwner))||store.isUserGlobalViewAdmin||store.isUserViewAdmin}
                  label="Per transaction limit"
                  onChange={(e) => {
                    setIsUpdated(false);
                    setErrorMessage("");
                    setErrorMsg((prev) => ({
                      ...prev,
                      isAnyFieldEmpty: false,
                      isTxnLimitNegative: false,
                      isTxnLimitExceeds: false,
                    }));
                    setTxnlimt(e.target.value);
                  }}
                  onWheel={(e) => e.target.blur()}
                  variant="outlined"
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      appearance: "none",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      maxHeight: "3.1rem",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    },
                  }}
                />
                {(errormsg.isTxnLimitNegative ||
                  errormsg.isTxnLimitExceeds) && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
                {errormsg.isAnyFieldEmpty && Txnlimt == "" && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>

              <div className={styles.mobileMenu}>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={dailyLimit}
                  type="number"
                  required
                  disabled={(!(!adminEnabled || store.isUserOwner))||store.isUserGlobalViewAdmin||store.isUserViewAdmin}
                  label="Daily limit"
                  variant="outlined"
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                      fontSize: "1rem",
                    },
                  }}
                  onChange={(e) => {
                    setErrorMessage("");
                    setDailyLimit(e.target.value);
                    setIsUpdated(false);
                  }}
                  onWheel={(e) => e.target.blur()}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      maxHeight: "3.1rem",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    },
                  }}
                />

                {(errormsg.isDailyLimitNegative ||
                  errormsg.isDailyLimitExceedsMonthly) && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
                {errormsg.isAnyFieldEmpty && dailyLimit == "" && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>

              <div className={styles.mobileMenu}>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={MonthlyLimit}
                  type="number"
                  required
                  disabled={(!(!adminEnabled || store.isUserOwner))||store.isUserGlobalViewAdmin||store.isUserViewAdmin}
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                    },
                  }}
                  onChange={(e) => {
                    setErrorMessage("");
                    setIsUpdated(false);
                    setMonthlyLimit(e.target.value);
                  }}
                  onWheel={(e) => e.target.blur()}
                  label="Monthly limit"
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      maxHeight: "3.1rem",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    },
                  }}
                />
                {errormsg.isMonthlyLimitNegative && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
                {errormsg.isAnyFieldEmpty && MonthlyLimit == "" && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>
            </div>
            {console.log("store.isUserOwner", store.isUserOwner)}
            {(!adminEnabled || store.isUserOwner) &&
              store.isUserOwner &&
              !ownerEnabled && (
                <div className={styles.mobileMenuContainer12}>
                  <div className={styles.mobileMenuele12}>Admin</div>
                  <button
                    className={styles.mobileMenuele2btn}
                    onClick={() => {
                      setIsUpdated(false);
                      if (adminEnabled) {
                        setAdminEnabled(false);
                      } else {
                        setAdminEnabled(true);
                      }
                    }}
                  >
                    {adminEnabled ? (
                      <img
                        alt=""
                        src="/Track(Active).svg"
                        className={styles.btn_img}
                      />
                    ) : (
                      <img alt="" src="/Track.svg" className={styles.btn_img} />
                    )}
                  </button>
                </div>
              )}
            {(!adminEnabled || store.isUserOwner) && !ownerEnabled && (
              <div className={styles.mobileMenuContainer12}>
                <div className={styles.mobileMenuele12}>User</div>
                <button
                  className={styles.mobileMenuele2btn}
                  onClick={() => {
                    setIsUpdated(false);
                    if (userEnabled) {
                      setUserEnabled(false);
                    } else {
                      setUserEnabled(true);
                    }
                  }}
                >
                  {userEnabled ? (
                    <img
                      alt=""
                      src="/Track(Active).svg"
                      className={styles.btn_img}
                    />
                  ) : (
                    <img alt="" src="/Track.svg" className={styles.btn_img} />
                  )}
                </button>
              </div>
            )}
          </div>
          {isUpdated && successMessage && (
            <div className={styles.Completed}>
              <img
                className={styles.Completedicon}
                alt=""
                src="/check-circle.svg"
              />
              <div className={styles.CompletedText}>{successMessage}</div>
            </div>
          )}{console.log("store.isUserGlobalViewAdmin",store.isUserGlobalViewAdmin)
          }
          {console.log("store.isUserViewAdmin",store.isUserViewAdmin)
          }
          {console.log((!store.isUserGlobalViewAdmin&&!store.isUserViewAdmin))}
          {(!adminEnabled || store.isUserOwner) &&(!store.isUserGlobalViewAdmin&&!store.isUserViewAdmin) &&(
            <div
              className={styles.loadsButtons}
              onClick={() => {
                onFrameButtonClick();
              }}
            >
              Submit
            </div>
          )}
          {companyStore.userType == "PineLabUser" && (
            <div className={styles.finalCupiLogo}>
              <img
                className={styles.escrowLogo}
                alt=""
                src="/PineLabsLogo.svg"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

EditUserLimits.propTypes = {
  className: PropTypes.string,
};

export default EditUserLimits;
